import React, { useEffect, useState } from "react";
import CheckOrderStatus from "./uploadPage";
import {  toast } from 'react-toastify';
import HelpAndSupport from "./component";
import SampleImg from '../../assets/sample_img.png'
import { use } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import axios from "axios";
import WaitingLoder from "../../Loader/component";
import NoInternet from "../../NoInterNet/component";
import logger from "../../Utils/logger";
const HelpAndSupportContainer = (props) => {
const { makeApiRequest } = useApiRequest()
//const {id} =useParams()
   const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get('id');
    //logger.log("props helpandsupport container",props)
  const [image, setImage] = useState(SampleImg);
  const [imagePath, setImagePath] = useState("");
  const [uploadSumbitFlag,setUploadSumbitFlag]=useState(false)
  
  const [imageUploadUI,setImageUploadUI]=useState(true)
  const [selectedImage, setSelectedImage] = useState(image);
  const [previewImage, setPreviewImage] = useState(null);


  const [orderSuccessflag,setOrderSuccessflag]=useState(false)
  const [orderNotFoundflag,setOrderNotFoundflag]=useState(false)
  const [orderPlacedflag,setOrderPlacedflag]=useState(false)
  const [orderAbandonedflag,setOrderAbandonedflag]=useState(false)
  const [orderFailedflag,setOrderFailedflag]=useState(false)
  const [orderCancleflag,setOrderCancleflag]=useState(false)
  const [orderPartiallyflag,setOrderPartiallyflag]=useState(false)
const [fileName, setFileName] = useState('');
const [fileSize, setFileSize] = useState('');


  const [orderNotFoundREflag,setOrderNotFoundREflag]=useState(false)
  const [orderPlacedREflag,setOrderPlacedREflag]=useState(false)
  const [orderAbandonedREflag,setOrderAbandonedREflag]=useState(false)
  const [orderFailedREflag,setOrderFailedREflag]=useState(false)
  const [orderCancleREflag,setOrderCancleREflag]=useState(false)
  const [orderPartiallyREflag,setOrderPartiallyREflag]=useState(false)
  const [orderCreated,setOrderCreated]=useState(false)
  const [whatsappnum,setWhatsappnum]=useState(null)
const [uploadingFlag,setuploadingFlag]=useState(false)

const [orderReport,setOrderReport]=useState(null)
const [tickeRaiseSuccesFlag,setTickeRaiseSuccesFlag]=useState(false)

  const [openWhatsappModal, setOpenWhatsappModal] = useState(false)

const [raiseTicketData,setRaiseTicketData]=useState(null)

const [uploadFailed,setUploadFailed]=useState(false)
const [uploaderror,setUploaderror]=useState(null)
const [serverBusy,setServerBusy]=useState(false)
const [orderhistory,setOrderhistory]=useState(null)
const [showLogin,setShowLogin]=useState(false)
const [showBottomFlag,setShowBottomFlag]=useState(true)

const [blanckUI,setBanckUI]=useState(false)
    const location = useLocation();
     const params = new URLSearchParams(location.search);
  
  
  
    const isWebview = params.get("webview")
      const mobileNumber = params.get("mobileNumber")



  // ✅ Offline state — drives the NoInternet screen
  const [noInternet, setNoInternet] = useState(false);


        const handleNetworkError = (error) => {
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  };


    
        // ─── Online / offline listeners ───────────────────────────────────────────

  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);
    const goOnline = () => {
      setNoInternet(false);
      //setLoader(true);

 

    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

useEffect(()=>{
  fetchUserDetails()
  if(id){
    setBanckUI(true)
    setLoader(true)
handleFindOrderStatus(id)
  }

},[])


  const handleResponseOrderSerachImage=(response)=>{
setLoader(false)
//logger.log("response.order_id",response.data.response.order_id)
handleFindOrderStatus(response.data.response.order_id,response.data.response.media_url)
    //logger.log("response.data.response.is_refunded", response.data.response.is_refunded==false);
    setImagePath(response.image_path);
    setLoader(false)


if(response.data.response.oder_status=="Payment failed"){
if(response.data.response.is_refunded=="true"){

}

setImageUploadUI(false)
setOrderCreated(true)


}

    

        
  

            
    
          
    

  


    
  


}
  
  const handleErrorOrderSerachImage=(err)=>{
    //logger.log("error",err.code)
    setLoader(false)
    setuploadingFlag(false)
    //logger.log("Error:tahzeeb", err.response.data.statusMessage);

    const statusCode = err&&err.response&&err.response.status

    // Server overloaded / rate limited
    if(statusCode==429 || statusCode==503){
      setServerBusy(true)
      return
    }

    setUploadFailed(true)

 setUploaderror("Uploading Failed")

if(err.code=="ERR_NETWORK"){
 setUploaderror("NetWork Error")

}

if(err&&err.response&&err.response.data.status=="FAILURE"){
    setUploaderror(err.response.data.statusMessage)
}

if(err&&err.response&&err.response.data.statusCode=="BAD_REQUEST"){
     setUploaderror("Uploading Failed")
}
    toast.error(`${err&&err.response&&err.response.data.statusMessage}`, {
        position: "top-right",
        autoClose: 5000,
    });
  }

  const handleServerBusyRetry=()=>{
    setServerBusy(false)
    UploadImgBtn()
  }


const UploadImgBtn = async () => {
  setuploadingFlag(true);

  if (!image) {
    setuploadingFlag(false);
    return;
  }

  const formData = new FormData();
  formData.append("image", image);

  let UserJWTAuth = localStorage.getItem("UserJWTAuth");
  let uuid = localStorage.getItem("uuid");

  // 🧩 Fix: if uuid missing, regenerate
 /*  if (!uuid) {
    uuid = crypto.randomUUID();
    localStorage.setItem("uuid", uuid);
  } */

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/support/help/self/order/search/image`,
      formData,
      {
        headers: {
          ///Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          //"x-device-id": uuid,
        },
      }
    );
    handleResponseOrderSerachImage(response);
  } catch (error) {
    // Debug reason for invalid auth
   // logger.error("Upload failed:", error?.response?.data || error);
    handleErrorOrderSerachImage(error);
  } finally {
    setuploadingFlag(false);
  }
};




const UploadImgFun = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const validImageTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];

  // Validate image type
  if (!validImageTypes.includes(file.type)) {
    toast.error("Only image files (JPG, PNG, WEBP) are allowed.", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  // ✅ Validate file size (max 2MB)
  const maxSizeInBytes = 1 * 1024 * 1024; // 2 MB

  if (file.size > maxSizeInBytes) {
    toast.error("Image size must not exceed 1MB.", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  setImage(file);
  setSelectedImage(file);
  setFileName(file.name);

  const formattedSize = (file.size / 1024).toFixed(1); // KB
  setFileSize(formattedSize);

  const reader = new FileReader();
  reader.onloadend = () => {
    setPreviewImage(reader.result);
    setUploadSumbitFlag(true);
  };
  reader.readAsDataURL(file);
};




 



  const [loader,setLoader]=useState(false)

  useEffect(() => {
    //logger.log("HelpAndSupportContainer");
    fetchOrderHistory()
  }, []);

  const handleFindOrderStatus= (orderId,url) => {
   
  


    //logger.log("imageform--", formData);
    const UserJWTAuth = localStorage.getItem('UserJWTAuth');
 

makeApiRequest({
  
  url: `${process.env.REACT_APP_API_BASE_URL}/support/refund/${orderId}/status`,
  method: "POST",
  headers: {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json",
  },
  data: {
    mediaUrl: url
  },
  handleSuccess: (res) => handleResponseFindOrderStatus(res),
  handleError: (error) => handleErrorFindOrderStatus(error),
});




  };

const handleResponseFindOrderStatus=(res)=>{
  setuploadingFlag(false)
  //logger.log("FindOrderStatus",res)
  setOrderReport(res)
  setLoader(false)
  setBanckUI(false)

}
const handleErrorFindOrderStatus=( )=>{
  setuploadingFlag(false)
  setLoader(false)
   setBanckUI(false)
}  



  const handleTicket = (mobileNo) => {
   
  


    //logger.log("imageform--", formData);
    const UserJWTAuth = localStorage.getItem('UserJWTAuth');
    setLoader(true)
  

makeApiRequest({
 
  url: `${process.env.REACT_APP_API_BASE_URL}/support/api/v2/raise`,
  method: "POST",
  headers: {
    //Authorization: `Bearer ${UserJWTAuth}`,
    //"x-device-id": localStorage.getItem("uuid"),
  },
data: {
  mobileNo: mobileNo
    ? mobileNo.startsWith("+91")
      ? mobileNo
      : `+91${mobileNo}`
    : whatsappnum.startsWith("+91")
    ? whatsappnum
    : `+91${whatsappnum}`,
  orderId: orderReport.data.orderId,
  ticketId: orderReport.data.ticketId,
},

  handleSuccess: (res) => handleResponseRaisedTicket(res),
  handleError: (error) => handleErrorRaisedTicket(error),
});

  };

const handleResponseRaisedTicket=(res)=>{
  setLoader(false)
  //logger.log("handleResponseRaisedTicket",res.data)

setRaiseTicketData(res.data)
setOpenWhatsappModal(false)
setTickeRaiseSuccesFlag(true)
}
const handleErrorRaisedTicket=(err)=>{
  setLoader(false)
  //logger.log("handleErrorRaisedTicket",err.response.data.statusMessage)
     toast.error(`${err.response.data.statusMessage}`, {
        position: "top-right",
        autoClose: 5000,
    });

}
 const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
      setUploadSumbitFlag(true)
    }
  };
 


    const fetchUserDetails = () => {
       const token = localStorage.getItem("UserJWTAuth");
         const deviceId = localStorage.getItem("uuid");
      if (!token) return;
  
      makeApiRequest({
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/profile/details`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          request: { oauthToken: `Bearer ${token}` },
        },
        handleSuccess: handleResponseUserDetails,
        handleError: handleErrorUserDetails,
      });
    };
  
    const handleResponseUserDetails = (res) => {
  //logger.log("handleResponseUserDetails",res.data.response)
  localStorage.setItem("mobileNo",res.data.response.mobileNo)
  
  
      const data = res?.data?.response;
      if (data) {
        localStorage.setItem("referCode", data.referCode);
        //setProfileData(data);
      }
     // setLoader(false);
    };
  
    const handleErrorUserDetails = (error) => {
      setLoader(false);
      const status = error?.response?.status;
  
      if (status === 401 || status === 403) {
        const google_jwt = localStorage.getItem("google_jwt");
        if(google_jwt) { 
          //setGoogle_Pop_flag(true)
  
        } 
      } else {
     
      }
    };
  
const fetchOrderHistory = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");



  makeApiRequest({
    
    url: `${process.env.REACT_APP_API_BASE_URL}/order/order/orderhistory`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
    },
    data: {
     request:{}
    },
    handleSuccess: (res) => {
      //logger.log("✅ Payment Initiated Successfully:", res);
      handleResponseOrderHistory(res);
    },
    handleError: (err) => {
      logger.error("❌ Payment Initiation Failed:", err);
      handleErrorOrderHistory(err);
    },
  });

};



const handleErrorOrderHistory=(error)=>{
  //logger.log("error---------------",error)
   
  if(error.response.status==401|| error.response.status==403){

   // logger.log("khan handleErrorVmInventory", error.response.data.status.code);
    //Logout
    //localStorage.removeItem("UserJWTAuth")
    setShowLogin(true);
    setShowBottomFlag(false)
}
  setLoader(false)
}

const handleResponseOrderHistory=(res)=>{
  //logger.log("handleResponseOrderHistory",res.data.response[0])
  //setOrderhistory(res.data.response)

if (Array.isArray(res.data.response) && res.data.response.length === 0) {
  setShowLogin(false);
}
  setLoader(false)
}
  if (noInternet) return <NoInternet />;
  return (
    <>
    {loader&&<WaitingLoder/>}
     
    {  blanckUI?<WaitingLoder/>:
    <CheckOrderStatus
        UploadImgBtn={UploadImgBtn}
      
        handleImageUpload={handleImageUpload}
        loader={loader}
        imageUploadUI={imageUploadUI}
        orderSuccessflag={orderSuccessflag}
        orderNotFoundflag={orderNotFoundflag}
        previewImage={previewImage}
        orderPlacedflag={orderPlacedflag}
        orderAbandonedflag={orderAbandonedflag}
        orderFailedflag={orderFailedflag}
        orderCancleflag={orderCancleflag}
        orderPartiallyflag={orderPartiallyflag}
        UploadImgFun={UploadImgFun}


  orderNotFoundREflag={orderNotFoundREflag}
  orderPlacedREflag={orderPlacedREflag}
  orderAbandonedREflag={orderAbandonedREflag}
  orderFailedREflag={orderFailedREflag}
  orderCancleREflag={orderCancleREflag}
  orderPartiallyREflag={orderPartiallyREflag}
  orderCreated={orderCreated}
  handleTicket={handleTicket}
  setWhatsappnum={setWhatsappnum}
  whatsappnum={whatsappnum}
  image={image}
uploadSumbitFlag={uploadSumbitFlag}
selectedImage={selectedImage}
uploadingFlag={uploadingFlag}
fileName={fileName}
fileSize={fileSize}
orderReport={orderReport}
setOrderReport={setOrderReport}
setTickeRaiseSuccesFlag={setTickeRaiseSuccesFlag}
tickeRaiseSuccesFlag={tickeRaiseSuccesFlag}
setOpenWhatsappModal={setOpenWhatsappModal}
openWhatsappModal={openWhatsappModal}
raiseTicketData={raiseTicketData}
uploadFailed={uploadFailed}
setUploadFailed={setUploadFailed}
uploaderror={uploaderror}
serverBusy={serverBusy}
setServerBusy={setServerBusy}
onServerBusyRetry={handleServerBusyRetry}
setLoader={setLoader}
orderhistory={orderhistory}
showLogin={showLogin}
showBottomFlag={showBottomFlag}



      />}
    </>
  );
};


  
  export default  HelpAndSupportContainer;
